import { css } from "@emotion/react";

import { colors } from "@styles";

export const errorBoundary = css`
  display: flex;
  justify-content: center;
  padding: 3.75rem 0 0 0;
`;

export const content = css`
  padding: 0 1rem;
`;

export const title = css`
  color: ${colors.primary};
`;

export const subTitleContainer = css`
  display: flex;
  align-items: center;
  margin: 0 0 0.75rem 0;
`;

export const subTitle = css`
  color: ${colors.primary};
`;

export const text = css`
  font-size: 1rem;
  max-width: 27rem;
  margin-bottom: 1rem;
  line-height: 1.75rem;
  color: ${colors.grey.base};
`;

export const logo = css`
  height: 1.375rem;
  width: auto;
  margin: 0 0.625rem 0 0;
`;
